
import React, { Component } from 'react'
import CommonTableModule from './../CommonTable/CommonTableModule';
import { Card, Alert, Spinner, Badge, Button } from "react-bootstrap";
import axios from "axios";
import { DateTimeFormat } from '../DateFormat/DateTimeFormat';
import CommonLoader from '../loaderComponent/CommonLoader';
import { hasPermission } from '../../utils/usePermission';

export default class FineList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fineLists: [],
      loading: true,
      hasError: false,
      errMsg: ""
    };
  }


  async componentDidMount() {
    this.setState({ loading: true })
    const token = localStorage.getItem("token");
    if (!token) {
      this.setState({ hasError: true, errMsg: "Unauthorized! Please log in.", loading: false });
      return;
    }
    const headers = { Authorization: `Bearer ${token}` };
    try {
      const response = await axios.get('/fine/list', { headers });
      this.setState({ fineLists: response?.data });
      setTimeout(() => {
        this.setState({ loading: false });
      }, 200);
    } catch (error) {
      console.error("Error fetching fine:", error);
      let errorMessage = "Failed to load fine data.";

      if (error.response && error.response.status === 403) {
        errorMessage = "Access Denied! Admin privileges required.";
      }
      this.setState({ hasError: true, errMsg: errorMessage, loading: false });
    }
  }

  handleAddFine = () => {
    this.props.history.push('/fine-add')
  }
  render() {
    const columns = [
      { key: "id", label: "S. no" },
      { key: "empid", label: "Employee Id" },
      {
        key: "user",
        label: "Name",
        render: (row) => {
          return row?.fullName || "N/A"
        },
      },
      { key: "amount", label: "Amount" },
      { key: "reason", label: "Reason" },
      {
        key: "date",
        label: "Date",
        render: (value) => DateTimeFormat(value), // Converts to "MM-DD-YYYY hh:mm AM/PM"
      },
      { key: "month", label: "Month" },
      { key: "year", label: "Year" }

    ];
    return (
      <div className="container-fluid pt-4">

        <CommonLoader isLoading={this.state.loading}>
          {hasPermission('M13S1') && (
            <div className='add-role'>
              <Button variant="primary" className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button" onClick={this.handleAddFine}> <i className="fa fa-plus-circle"></i> Add Fine</Button>
            </div>
          )}
          <Card className="shadow-sm rounded border-0">
            <Card.Header>
              <b>Fine List</b>
            </Card.Header>
            <Card.Body>
              {this.state.hasError ? (
                <Alert variant="outline-danger" className="m-3">
                  {this.state.errMsg}
                </Alert>
              ) : (
                <CommonTableModule columns={columns} data={this.state.fineLists} />
              )}
            </Card.Body>
          </Card>
        </CommonLoader>
      </div>
    )
  }
}
